let neighborhoods = [
    "הכל",
    'אלנקווה',
    'אריאל שרון',
    'בבא סאלי',
    'בר כוכבא ',
    'גולדה מאיר',
    'דוד רזיאל',
    'דרך השלום',
    'האורן',
    'הגבעה',
    'הגבעה הצרפתית',
    'המעפיל',
    'העליה עבדה',
    'העצמאות',
    'הרותם',
    'הרמה',
    'השחר',
    'התפוצות',
    'וילות מבט',
    'ורדימון',
    'יגאל אלון',
    'לדוגמא',
    'מגדלי רז׳ואן',
    'מד׳ המעפילים',
    'ממשית',
    'מרחבים',
    'מתתיהו הכהן',
    'נווה דוד',
    'נווה חורש',
    'ניצחון א',
    'ניצחון ב',
    'עזרא ונחמיה',
    'צפונית A',
    'צפונית B',
    'צפונית C',
    'צפונית E,D',
    'רחבת השיטה',
    'שבעת המינים',
    'שיבוצים המלאכה',
    'שכונת הרצל',
    'תשלו״ז',
    'אחר...'
]

export default neighborhoods